import { render } from "./AppMenuReport.vue?vue&type=template&id=fd0c24d4&scoped=true"
import script from "./AppMenuReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuReport.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuReport.vue?vue&type=style&index=0&id=fd0c24d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0c24d4"],['__file',"src/core/layout/AppMenuReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd0c24d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd0c24d4', __exports__)) {
    console.log('reload')
    api.reload('fd0c24d4', __exports__)
  }
  
  module.hot.accept("./AppMenuReport.vue?vue&type=template&id=fd0c24d4&scoped=true", () => {
    console.log('re-render')
    api.rerender('fd0c24d4', render)
  })

}


export default __exports__